export default __webpack_public_path__ + "static/media/seal.e597caff.jpeg";